import { OnboardingBrandVoiceFinishedNew } from 'features/onboardingJourney/new-onboarding-2025/onboarding-finished-new';

export const OnboardingBrandVoiceFinished = () => {
  return <OnboardingBrandVoiceFinishedNew />;
};
